import { render } from "./Van.vue?vue&type=template&id=3eea3822"
import script from "./Van.vue?vue&type=script&lang=js"
export * from "./Van.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Van.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3eea3822"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3eea3822', __exports__)) {
    api.reload('3eea3822', __exports__)
  }
  
  module.hot.accept("./Van.vue?vue&type=template&id=3eea3822", () => {
    api.rerender('3eea3822', render)
  })

}


export default __exports__